import(/* webpackMode: "eager", webpackExports: ["ServicePage"] */ "/vercel/path0/src/app/(pages)/(services)/sourcing-and-recruiting/service.tsx");
